<template>
    <div>
        <div v-if="show" class="modal-overlay">
            <div v-if="!sending" class="modal-content">
                <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                    <h2>{{ $t('copy-move-node') }}</h2>
                    <button type="button" class="close-btn" @click="transmute('close')">
                        <b-icon icon="x"></b-icon>
                    </button>
                </div>
                <div>
                    <NodeDrilldownSearch
                        @filtered-nodes="handleFilteredNodes"
                        @hasQuery="hasQuery"
                        :selectedNode="node"
                        view="transmute"
                    />
                    <div class="modal-actions">
                        <button type="button" class="btn btn-secondary" @click="transmute('close')">{{ $t('cancel') }}</button>
                        <button type="button" class="btn btn-primary" @click="transmute('move')" :disabled="!has_query">{{ $t('move') }}</button>
                        <button type="button" class="btn btn-info" @click="transmute('copy')" :disabled="!has_query">{{ $t('copy') }}</button>
                    </div>
                </div>
            </div>
            <ActionModal v-if="sending"
                :title="loadingText.title"
                :text="loadingText.loadingText"
            />
        </div>
    </div>
  </template>
  
  <script>
  import "@/styles/components/programmeCreate.scss"; 
  import NodeDrilldownSearch from "./NodeDrilldownSearch.vue";
import ActionModal from "../ActionModal.vue";

  export default {
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      node: {
        type: Object,
        default: () => {}
      },
      sending: {
        type: Boolean,
        default: () => false
      }
    },
    components: {
        NodeDrilldownSearch,
        ActionModal
    },
    data() {
      return {
        validate: false,
        errors: false, 
        filteredNodes: [],
        action : null,
        has_query: false
      };
    },
    methods: {
        handleFilteredNodes(val) {
            this.filteredNodes = val;
            return val;
        },
        transmute(action){
            this.action = action;
            this.$emit('action', {
                action: action,
                target_node: this.filteredNodes[0]
            })
        },
        hasQuery(payload){
            this.has_query = payload;
        }
       
    },
    computed: {
        loadingText(){
            if(this.action === "copy") return {title: this.$t("copying"), loadingText: this.$t('copying-hierarchy')}
            if(this.action === "move") return {title: this.$t("moving"), loadingText: this.$t('moving-hierarchy')}
            return {};
        }   
    }
  };
  </script>
  